module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("attach_money")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n      " + _vm._s(_vm.fullName) + " paid " + _vm._s(_vm.amountFormatted) + " on " + _vm._s(_vm.dateformat(_vm.item.date)) + "\n      "), (_vm.item.method) ? _c('span', [_vm._v("via " + _vm._s(_vm.item.method) + ".")]) : _vm._e(), _vm._v(" "), (_vm.item.reference) ? _c('span', [_vm._v("ref: " + _vm._s(_vm.item.reference))]) : _vm._e()]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('v-chip', {
    staticClass: "v-chip--x-small ml-0",
    attrs: {
      "color": "success",
      "outline": ""
    },
    on: {
      "click": function($event) {
        return _vm.gotoClient({
          id: _vm.item.customer_id
        })
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.fullName) + "\n        "), _c('v-icon', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _vm._l((_vm.item.related_invoices_formatted), function(invoice) {
    return _c('v-chip', {
      key: invoice.invoice_number,
      staticClass: "v-chip--x-small ml-0",
      attrs: {
        "outline": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          _vm.gotoPage('invoice', invoice.invoice_number.split('-')[1])
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("post_add")]), _vm._v("\n        " + _vm._s(invoice.invoice_number) + ".\n        " + _vm._s(_vm.formatCurrency(invoice.currency, invoice.invoice_amount)) + "\n        "), _c('v-icon', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "small": "",
        "right": ""
      }
    }, [_vm._v("open_in_new")])], 1)
  }), _vm._v(" "), _c('v-chip', {
    staticClass: "v-chip--x-small ml-0",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.showAppointments
    }
  }, [_vm._v("\n        " + _vm._s(_vm.appointments.length) + " appointments\n        "), _c('v-icon', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 2)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('strong', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.amountFormatted))])]), _vm._v(" "), (_vm.dialogs.appt) ? _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.dialogs.appt),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "appt", $$v)
      },
      expression: "dialogs.appt"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.appt
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline py-0 grey lighten-4"
  }, [_vm._v("\n        Appointments\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.appt = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.remoteAppts), function(appt) {
    return [_c('appointment-list-item', {
      key: appt.id,
      attrs: {
        "with-color-coding": false,
        "with-status-chips": true,
        "appointment": appt
      },
      on: {
        "goto": function($event) {
          return _vm.gotoPage('appointment', appt.id)
        }
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (appt.id))
    })]
  })], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91a865ca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listitems/PaymentListItem.vue
// module id = 1496
// module chunks = 9